export const SHOW_MODAL = 'modal/show';
export const HIDE_MODAL = 'modal/hide';
